import { Component, Vue } from "vue-property-decorator";

// External components
import ToggleSwitch from "@/components/toggleSwitch/toggleSwitch";
import { Action, Getter, Mutation } from "vuex-class";

@Component({ components: { ToggleSwitch } })
export default class AutoGenerateOrders extends Vue {
  @Action action_updateSubscription;

  @Getter getCity;
  @Getter getSubscription;

  @Mutation SPINNER;

  isAutoGenerateOrdersActivated = false;

  mounted() {
    this.isAutoGenerateOrdersActivated = this.getSubscription.auto_generate_orders;
  }

  async onToggleAutoGenerateOrders() {
    this.SPINNER(true);
    try {
      const payload = {
        commerceId: this.getCity.id,
        subscriptionId: this.getSubscription.id,
        subscription: {
          subscription: {
            auto_generate_orders: !this.isAutoGenerateOrdersActivated,
          },
        },
      };
      await this.action_updateSubscription(payload);
      this.isAutoGenerateOrdersActivated = !this.isAutoGenerateOrdersActivated;
    } catch (error) {
      this.$swal({
        title: "Error",
        text: `No fue posible actualizar la suscripción. ${
          error.response && error.response.data && error.response.data.message
        }`,
      });
    }
    this.SPINNER(false);
  }
}
